import React from "react";

function TimeSlotButton({
    slot,
    onClick,
    disabled,
    isSelected,
    isExpired,
}) {

    return (

        <button
            disabled={disabled}

            onClick={() =>
                onClick(slot)
            }

            style={{
                ...styles.button,

                ...(isSelected
                    ? styles.selected
                    : {}),

                ...(isExpired
                    ? styles.expired
                    : {}),

                ...(disabled
                    ? styles.disabled
                    : {}),
            }}
        >

            {isExpired
                ? "Expired"
                : slot.time}

        </button>
    );
}

const styles = {

    button: {

        padding: "16px",

        borderRadius: "14px",

        border:
            "1px solid rgba(0, 255, 150, 0.3)",

        background:
            "rgba(255, 255, 255, 0.05)",

        color: "#fff",

        cursor: "pointer",

        transition:
            "all 0.2s ease-in-out",
    },

    selected: {

        background:
            "rgba(0, 255, 150, 0.2)",

        border:
            "1px solid rgba(0, 255, 150, 0.8)",

        boxShadow:
            "0 0 10px rgba(0, 255, 150, 0.3)",
    },

    expired: {

        background:
            "rgba(255, 107, 107, 0.12)",

        border:
            "1px solid rgba(255, 107, 107, 0.4)",

        color:
            "#ff9b9b",
    },

    disabled: {

        opacity: 0.45,

        cursor: "not-allowed",
    },
};

export default TimeSlotButton;